import React, { useContext, useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IAffiliateFees } from '../../api/interfaces'
import { ThemeContext } from '../../App'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { colors } from '../../const'
import { useChartData } from '../../hooks/useChartData'

async function getAffiliateFeesCumulativeConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_aff_fees', timeframe)) as IAffiliateFees[]
	const thorswapData = chartData.filter((row) => row.LABEL === 'THORSwap')
	const thorwalletData = chartData.filter((row) => row.LABEL === 'THORWallet')
	const othersData = chartData.filter((row) => row.LABEL === 'Others')
	const shapeShiftData = chartData.filter((row) => row.LABEL === 'ShapeShift')
	const asgardexData = chartData.filter((row) => row.LABEL === 'Asgardex')
	const trustwalletData = chartData.filter((row) => row.LABEL === 'TrustWallet')
	const ledgerData = chartData.filter((row) => row.LABEL === 'Ledger')
	const swapkitData = chartData.filter((row) => row.LABEL === 'Swapkit')
	const vultisigData = chartData.filter((row) => row.LABEL === 'Vultisig')

	const series1 = thorswapData.map((element: IAffiliateFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_FEE_USD }
	})
	const series2 = thorwalletData.map((element: IAffiliateFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_FEE_USD }
	})
	const series3 = othersData.map((element: IAffiliateFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_FEE_USD }
	})
	const series4 = swapkitData.map((element: IAffiliateFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_FEE_USD }
	})
	const series6 = shapeShiftData.map((element: IAffiliateFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_FEE_USD }
	})
	const series7 = asgardexData.map((element: IAffiliateFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_FEE_USD }
	})
	const series8 = vultisigData.map((element: IAffiliateFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_FEE_USD }
	})
	const series10 = trustwalletData.map((element: IAffiliateFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_FEE_USD }
	})
	const series11 = ledgerData.map((element: IAffiliateFees) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_FEE_USD }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'THORSwap',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[0]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series10,
			strokeWidth: 2,
			name: 'TrustWallet',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[1]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series11,
			strokeWidth: 2,
			name: 'Ledger',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[2]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'THORWallet',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[3]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series4,
			strokeWidth: 2,
			name: 'Swapkit',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[4]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series6,
			strokeWidth: 2,
			name: 'ShapeShift',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[5]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series7,
			strokeWidth: 2,
			name: 'Asgardex',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[6]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series8,
			strokeWidth: 2,
			name: 'Vultisig',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[7]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'Others',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[8]}`,
			unitSymbol: '$',
			barGroup: 'positive'
		}
	]

	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}

const AffiliateFeesCumulative = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getAffiliateFeesCumulativeConfig, '1m')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Total Affiliate Fees"
			chartDesc="Fees earned by affiliate partners from volume they bring to THORChain."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="36b3b6b9-9e9c-4eef-a42f-a31fe7af0775"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			sortByValueDesc={true}
		/>
	)
}

export default AffiliateFeesCumulative
